"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = Pagination;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _chevronButton = require("./chevron-button");
var _paginationButton = _interopRequireDefault(require("./pagination-button"));
var _styledPagination = require("./styled-pagination");
var _useMediaQuery = _interopRequireDefault(require("./useMediaQuery"));
var _utils = require("./utils");
var _excluded = ["currentPage", "numberOfPages", "callback", "dataTestId", "className", "seoUrl"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  currentPage: _propTypes["default"].number.isRequired,
  numberOfPages: _propTypes["default"].number.isRequired,
  callback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  seoUrl: _propTypes["default"].string
};
var defaultProps = {
  callback: undefined,
  dataTestId: undefined,
  className: undefined,
  seoUrl: undefined
};
function Pagination(_ref) {
  var currentPage = _ref.currentPage,
    numberOfPages = _ref.numberOfPages,
    callback = _ref.callback,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    seoUrl = _ref.seoUrl,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobile = (0, _useMediaQuery["default"])("(max-width: ".concat(_grid.gridConfig.s.maxWidth, ")"));
  var maxButtons = isMobile ? _utils.MAX_BUTTONS_MOBILE : _utils.MAX_BUTTONS_DESKTOP;
  var maxPages = numberOfPages > currentPage ? numberOfPages : currentPage;

  /* Change number of buttons if device is rotated */
  (0, _react.useEffect)(function () {
    maxButtons = isMobile ? _utils.MAX_BUTTONS_MOBILE : _utils.MAX_BUTTONS_DESKTOP;
  }, [isMobile]);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    pages = _useState2[0],
    setPages = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      return (0, _utils.generateButtonArray)({
        currentPage: currentPage,
        maxPages: maxPages,
        maxButtons: maxButtons,
        isMobile: isMobile,
        seoUrl: seoUrl
      });
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    pageUrls = _useState4[0],
    setPageUrls = _useState4[1];
  var prevPageUrl = pageUrls.prevPageUrl,
    nextPageUrl = pageUrls.nextPageUrl;
  (0, _react.useEffect)(function () {
    var _generateButtonArray = (0, _utils.generateButtonArray)({
        currentPage: currentPage,
        maxPages: maxPages,
        maxButtons: maxButtons,
        isMobile: isMobile,
        seoUrl: seoUrl
      }),
      newPages = _generateButtonArray.pages,
      newPrevPageUrl = _generateButtonArray.prevPageUrl,
      newNextPageUrl = _generateButtonArray.nextPageUrl;
    setPages(newPages);
    setPageUrls({
      prevPageUrl: newPrevPageUrl,
      nextPageUrl: newNextPageUrl
    });
  }, [currentPage, isMobile, maxPages, maxButtons, seoUrl]);
  return /*#__PURE__*/_react["default"].createElement(_styledPagination.StyledNav, _extends({
    "aria-label": "Pagination",
    className: className,
    "data-testid": dataTestId || 'fuse-pagination-data-testid'
  }, props), /*#__PURE__*/_react["default"].createElement(_chevronButton.ChevronButton, {
    currentPage: currentPage,
    label: _utils.PREVIOUS_PAGE,
    callback: callback,
    numberOfPages: maxPages,
    dataTestId: dataTestId,
    seoHref: prevPageUrl
  }), /*#__PURE__*/_react["default"].createElement(_styledPagination.OlStyled, null, pages && pages.map(function (_ref2) {
    var label = _ref2.label,
      href = _ref2.href;
    return /*#__PURE__*/_react["default"].createElement(_paginationButton["default"], {
      key: "Page-".concat(label),
      text: label,
      currentPage: currentPage,
      callback: callback,
      dataTestId: dataTestId,
      seoHref: seoUrl && href
    });
  })), /*#__PURE__*/_react["default"].createElement(_chevronButton.ChevronButton, {
    currentPage: currentPage,
    label: _utils.NEXT_PAGE,
    callback: callback,
    numberOfPages: maxPages,
    dataTestId: dataTestId,
    seoHref: nextPageUrl
  }), /*#__PURE__*/_react["default"].createElement(_styledPagination.SrPoliteText, null, "Page ".concat(currentPage, " selected")));
}
Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
Pagination.displayName = 'Pagination';
var _default = exports["default"] = Pagination;